import Typography from '@repo/ui/typography'
import { useEffect } from 'react'

import withTheme from '../../components/hoc/with-theme'
import AuthLayout from '../../components/layouts/auth-layout'
import { UserType } from '../../components/pages/login/utils'
import { useSearchParams } from '../../lib/hooks/use-search-params'
import useTranslate from '../../lib/hooks/use-translate'

export const ClientCheckEmailPage = () => {
  const { searchParams } = useSearchParams<{ user: UserType }>()
  const userType = searchParams.user ?? 'client'
  const { t } = useTranslate()

  useEffect(() => {
    document.querySelector('html')?.setAttribute('data-theme', userType)
  }, [userType])

  return (
    <AuthLayout text="Bienvenue!" variant={userType === 'client' ? 'client' : 'staff'}>
      <div className="mobile:mt-16">
        <div
          className={
            'border border-grey-light w-full rounded-lg p-4 shadow-[0px_12px_26px_0px_#93939333]'
          }
        >
          <img src="/email-alert.png" alt="email" className={'w-20 h-20 mb-4'} />
          <Typography variant={'h4'} className={'mb-2 mobile:text-white'}>
            {t('magic.link.check.inbox')}
          </Typography>
          <Typography variant={'label-medium'} className={'text-grey-light-active mb-4'}>
            {t('magic.link.text')}
          </Typography>
        </div>
      </div>
    </AuthLayout>
  )
}

export default withTheme(ClientCheckEmailPage, 'client')
